import React from "react";

const ServiceCardSection3 = (props) => {
  return (
    <div className="icon-item flex w-11/12 flex-col items-center py-16 text-center ">
      <div className="rounded-full bg-white p-5">
        <img
          className="h-28 w-fit"
          src={props.image}
          alt=""
        />
      </div>
      <div className="item my-10">
        <h2 className="one text-2xl font-bold">{props.heading}</h2>
        <br />
        <p className="text-xl">
         {props.para}
        </p>
      </div>
    </div>
  );
};

export default ServiceCardSection3;
